import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

function Team() {

  return (

    <>
      <>
        <Header />
        <>
          {/* Page Header Section Start */}
          <div className="page-header bg-section parallaxie">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  {/* Page Header Box Start */}
                  <div className="page-header-box">
                    <h1 className="text-anime-style-3" data-cursor="-opaque">
                      Management Team
                    </h1>

                  </div>
                  {/* Page Header Box End */}
                </div>
              </div>
            </div>
          </div>
          {/* Page Header Section End */}
              {/* Our Testimonial Section Start */}
              <div className="our-testimonial">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-5">
                                    {/* Our Testimonial Content Start */}
                                    <div className="our-testimonial-content">
                                        {/* Section Title Start */}
                                        <div className="section-title section-title-center">
                                            <h3 className="wow fadeInUp">Our Organizing committee members</h3>
                                            <h2 className="text-anime-style-3" data-cursor="-opaque">
                                                Meet the Visionaries Behind Konark Patha Utsav
                                            </h2>
                                            <p className="wow fadeInUp" data-wow-delay="0.2s">
                                                The Konark Patha Utsav Organising Committee is a dedicated team of passionate individuals committed to bringing this vibrant festival to life. With diverse expertise and a shared love for culture, they work tirelessly behind the scenes to ensure seamless execution of every idea.
                                            </p>
                                        </div>
                                        {/* Section Title End */}
                                        {/* Our Testimonial Button Start */}
                               
                                               {/* Festival vibes Body Start */}
                                        <div
                                            className="festival-vibes-body wow fadeInUp"
                                            data-wow-delay="0.6s"
                                        >
                                            <div className="festival-vibes-body-list">
                                                <ul>
                                                    <li>Rabindranath Bahinipati</li>
                                                    <li>Mangaraj Muduli</li>
                                                    <li>Pratap Rout</li>
                                                    <li>Kamadev Biswal</li>
                                                    <li>Bamadev Aluka</li>
                                                    <li>Sumitra Sikari</li>
                                                    <li>Bauribandhu Sahoo</li>
                                                    <li>Pratap Gochhayat.</li>
                                                    <li>Manorama Dash</li>
                                                    <li>Rita mishra</li>
                                                    <li>Rajkishore Mohapatra</li>
                                                    <li>Ajay pattanaik</li>
                                                    <li>Ram Krushna Mohanty</li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* Festival vibes Body End */}
                                        <br></br>
                                        <div
                                            className="our-testimonial-btn wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <a href="testimonial.html" className="btn-default">
                                                View All Reviews
                                            </a>
                                        </div>
                                        {/* Our Testimonial Button End */}
                                    </div>
                                    {/* Our Testimonial Content End */}
                                </div>
                                <div className="col-lg-7">
                                    {/* Testimonial Item Box Start */}
                                    <div className="testimonial-item-box">
                                            {/* Festival Vibes Image Start */}
                                    <div className="festival-vibes-image">
                                        <figure className="image-anime ">
                                            <img src="images/team.jpeg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Festival Vibes Image End */}
                                    </div>
                                    {/* Testimonial Item Box End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Our Testimonial Section End */}

        </>

        <Footer />
      </>

    </>
  );
}

export default Team;